import {
  Box,
  Button,
  Modal,
  Paper,
  Typography,
  IconButton,
} from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
import { clearDiagnosisCompleteness } from "../../../store/slices/diagnosisSlice";
import { endDiagnosticSession } from "../../../store/thunks/sessionThunks";
import { useAppDispatch, useAppSelector } from "../../../store";
import { useNavigate } from "react-router-dom";

interface EndDiagnosticModalProps {
  open: boolean;
  onClose: () => void;
}

export const EndDiagnosticModal = ({
  open,
  onClose,
}: EndDiagnosticModalProps) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const handleEndDiagnostic = async () => {
    // End the diagnostic session before navigating back
    await dispatch(endDiagnosticSession());
    // Clear diagnosis completeness
    dispatch(clearDiagnosisCompleteness());
    // Navigate back to diagnostic page
    navigate("/diagnostic");
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Paper
        sx={{
          backgroundColor: "background.paper",
          padding: 4,
          borderRadius: 2,
          textAlign: "left",
          maxWidth: 400,
          width: "100%",
          position: "relative",
        }}
      >
        <Typography variant="h6" sx={{ marginBottom: 1 }}>
          Are you sure you want to leave?
        </Typography>

        <Typography
          variant="body2"
          sx={{ marginBottom: 3, color: "text.primary", textAlign: "left" }}
        >
          If you leave this page, data from this diagnostic session will be
          lost.
        </Typography>

        <Box sx={{ display: "flex", gap: 1, flexDirection: "row-reverse" }}>
          <Button
            onClick={handleEndDiagnostic}
            variant="outlined"
            size="small"
            sx={{
              borderColor: "rgba(185, 28, 28, 0.28)",
              color: "#991b1b",
              backgroundColor: "rgba(254, 242, 242, 0.72)",
              padding: "7px 16px",
              fontSize: "0.875rem",
              fontWeight: 500,
              textTransform: "none",
              borderRadius: "8px",
              "&:hover": {
                borderColor: "rgba(185, 28, 28, 0.42)",
                backgroundColor: "rgba(254, 226, 226, 0.82)",
              },
            }}
          >
            Leave Page
          </Button>

          <Button
            onClick={onClose}
            variant="outlined"
            size="small"
            sx={{
              color: "#111827",
              borderColor: "rgba(15, 23, 42, 0.18)",
              backgroundColor: "#ffffff",
              padding: "7px 16px",
              fontSize: "0.875rem",
              fontWeight: 500,
              textTransform: "none",
              borderRadius: "8px",
              "&:hover": {
                borderColor: "rgba(51, 153, 163, 0.34)",
                backgroundColor: "rgba(51, 153, 163, 0.08)",
              },
            }}
          >
            Cancel
          </Button>
        </Box>
      </Paper>
    </Modal>
  );
};
